module.exports = __webpack_public_path__ + "static/media/leg3.bc225cd4.png";